import { FC, PropsWithChildren } from 'react';

import { AnimatePresence } from 'framer-motion';

import { Button, HStack } from '@ui-furniture/elements';
import { x } from '@ui-furniture/style';
import { LineIcon } from '@ui-furniture/ui/line-icon';
import { Tooltip } from '@ui-furniture/ui/tooltip';

export const RestoreContainer: FC<
  PropsWithChildren<{
    isEditing: boolean;
    restore: () => void;
  }>
> = ({ isEditing, restore, children }) => (
  <HStack alignSelf='flex-end' alignItems='flex-end'>
    {children}

    <AnimatePresence>
      {isEditing ? (
        <Tooltip
          tooltipContent='Reset the questions and data to this point'
          placement='left'
        >
          <Button
            type='button'
            variant='blank'
            onClick={restore}
            textAlign='right'
            p='md'
            display='flex'
          >
            <x.span alignItems='center' color='palette-primary'>
              <LineIcon name='undo' size='28px' />
            </x.span>
          </Button>
        </Tooltip>
      ) : null}
    </AnimatePresence>
  </HStack>
);
